import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import {
  ActivatedRoute,
  Router,
  RouterState,
  RouterStateSnapshot
} from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppSettings } from './../../../shared/constants/app-settings';
import { Producto } from './../../../shared/models/producto';
import { PedidosService } from './../servicios/pedidos.service';

export interface trackingObject {
  telefono_destinatario: string | number;
  id_pedido_o_guia: string | number;
}

@Component({
  selector: 'app-rastreo',
  templateUrl: './rastreo.component.html',
  styleUrls: ['./rastreo.component.scss'],
})
export class RastreoComponent implements OnInit, AfterViewInit {
  @ViewChild('openModalButton') openModalButton;
  formRastreo: FormGroup;
  producto: Producto;
  fileUrl;
  visible = false;
  public visibleUrl = false;
  guiaArr: string[];
  urlWhatsapp = AppSettings.WHATSAPP_API;

  estado: string;
  enviaInter = false;
  checkedA = false;
  checkedP = false;
  checkedDev = false;
  checkedProInd = false;
  checkedInd = false;
  checkedNo = false;
  checkedD = '';
  checkedR = '';
  checkedPrep = '';
  checkedE = '';
  valueCheck = '0%';
  bgcheck = '#fff';

  fecha: string;
  anno: number;
  mes: number;
  dia: number;
  fecha_f: any;

  //Servientrega historial
  history;

  // MODAL
  muestra: boolean = false;
  historial: boolean = false;

  // INPUT NUMBER
  numberGuide: any;
  showSectionPhone: boolean = true;
  showValidatorData: boolean = true;
  showInput: boolean = false;
  phoneNumber: number;
  showErrorInput: boolean;
  messageInputPhone: string;
  numberAttempts = 0;

  constructor(
    private formBuild: FormBuilder,
    private pedidorService: PedidosService,
    private SpinnerService: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private cookieService: CookieService
  ) {
    this.activatedRoute.params.subscribe(() => {
      const state: RouterState = router.routerState;
      const snapshot: RouterStateSnapshot = state.snapshot;
      if (snapshot.url !== '/pedidos/rastreo') {
        this.visibleUrl = true;
        // this.cargarPedidoByNumeroGuia(this.activatedRoute.snapshot.params.id);
        this.numberGuide = this.activatedRoute.snapshot.params.id;
        this.getTrackingDataGuide(this.activatedRoute.snapshot.params.id, '');
      }
    });
  }

  ngAfterViewInit(): void { }

  ngOnInit(): void {
    this.inicializarFormulario();
    this.validateCookie();
  }

  getTrackingDataGuide(guide: any, phone: any) {
    const objectToSend = this.setObjectTracking(guide, phone);
    const step = this.pedidorService.trackingGuide(objectToSend).subscribe({
      next: (v) => {
        console.log(v)
        if (v[0]['isSuccess'] === true) {
          const data = v[0]['result'];
          this.setInfo(data[0]);
          if (v[0]['message'] === 'Datos ofuscados' && phone !== '') {
            this.numberAttempts++;
            console.log('OFUSCADOS Y DIFERENTE DE VACIO', this.numberAttempts)
            if (this.numberAttempts >= 3) {
              this.showValidatorData = false;
              // FALTA IMPLEMENTAR CREAR COOKIE CON NUMERO DE GUIA PARA BLOQUEAR VALIDADOR POR 6 HORAS
              this.setCookie();
            }
          } else if (v[0]['message'] === 'Datos obtenidos con exito') {
            this.showSectionPhone = false;
          }
        } else {
          console.log(v[0]['errors']);
        }
      },
      error: (e) => {
        console.warn(e);
      },
      complete: () => {
        this.SpinnerService.hide()
        step.unsubscribe();
      },
    });
  }

  getLog(producto: any) {
    this.pedidorService.verificaLog(producto.id_registro).subscribe(resp => {
      return resp;
    }, err => {
      console.log('Error', err);
    });
    jQuery(document).ready(function () {
      $(".container").css('margin-bottom', '0');
    });
  }

  setInfo(producto: any) {
    if (this.router.url.includes('/r/')) {
      this.getLog(producto);
    }
    this.estado = producto.estado_transportadora.toString();
    if (producto) {
      if (producto.guia) {
        if (producto.transportadora === AppSettings.ENVIA && this.estado != 'Anulada') {
          this.setStatus(producto, true);
        } else if (producto.transportadora === AppSettings.INTERRAPIDISIMO) {
          this.setStatus(producto, true);
        } else if (producto.transportadora === AppSettings.SERVIENTREGA) {
          this.setStatus(producto, true, 'Servientrega');
        } else {
          this.setStatus(producto, false);
        }
        this.setValoresFinales();
      } else {
        this.openCloseModal();
      }
    }
  }

  setStatus(product: any, showEnviaInter: boolean, conveyor?: string) {
    this.enviaInter = true;
    this.producto = product;
    //MODIFICACIÓN FECHA
    this.fecha = this.producto['fecha_pedido'];
    if (typeof this.fecha !== 'undefined') {
      this.anno = Number(this.fecha.substring(0, 4));
      this.mes = Number(this.fecha.substring(4, 6));
      this.dia = Number(this.fecha.substring(6, 8));
    }

    if (conveyor === 'Servientrega') {
      const lowCasse = this.estado.toLowerCase();
      this.estado = lowCasse.charAt(0).toUpperCase() + lowCasse.slice(1);
    }

    this.fecha_f = new Date(this.anno, this.mes - 1, this.dia);
    this.darEstado(this.estado);
  }

  setCookie() {
    let keyName = 'attempsGuideTrack';

    const obj = this.cookieService.getAll();
    const keys = Object.keys(obj);
    keys.forEach((elem: string) => {
      if (elem.includes(btoa(keyName))) {
        keyName = 'attempsGuideTrack' + Math.floor(Math.random() * 99);
        let response = keys.find((elem: string) => btoa(keyName) === elem);
        if (response !== undefined || response !== null) keyName = 'attempsGuideTrack' + Math.floor(Math.random() * 99);
      }
    })

    const expire = new Date();
    const time = Date.now() + ((3600 * 1000) * 2); // current time + 2 hours ///
    expire.setTime(time);

    this.cookieService.set(btoa(keyName), btoa(this.numberGuide), expire, '/', '');
  }

  setearInformacionInicial(numeroGuia: string): void {
    this.getTrackingDataGuide(numeroGuia, '');
    this.formRastreo.get('numeroGuia').setValue(numeroGuia);
  }

  validateCookie() {
    const obj = this.cookieService.getAll();
    const keys = Object.keys(obj);
    keys.forEach((elem: string) => {
      const dataKey = this.cookieService.get(elem);
      if (atob(dataKey) === this.numberGuide) {
        this.showSectionPhone = false;
      }
    })
  }

  /* cargarPedidoByNumeroGuia(numeroGuia: string): void {
    if (!numeroGuia) {
      this.openCloseModal();
    } else {
      this.visible = false;
      this.producto = {};
      this.SpinnerService.show();
      this.getTrackingDataGuide(this.activatedRoute.snapshot.params.id);

      this.pedidorService
        .getProductoByGuia(numeroGuia)
        .pipe(tap(() => ))
        .subscribe((productoRespuesta) => {
          const producto = productoRespuesta[0];
          // console.log('Producto: ', producto.id_registro);
          
        }, err => {
          console.log('Error', err);
        });
    }
  } */

  openCloseModal(): void {
    this.openModalButton.nativeElement.click();
  }

  setValoresFinales(): void {
    this.visible = true;
    this.fileUrl = null;
    this.guiaArr = this.producto.guia ? this.producto.guia.split('') : [];
  }

  setObjectTracking(guide: any, phone?: any): trackingObject {
    return {
      telefono_destinatario: phone ? phone : '',
      id_pedido_o_guia: guide
    }
  }

  comparaEnvia(status: string) {
    if (status.toLowerCase().includes('solucionado en malla') || status.toLowerCase().includes('solucionada en malla')) {
      this.estado = 'Solucionado en malla';
    }
    else if (status.toLowerCase().includes('redireccion')) {
      this.estado = 'Redireccion';
    }
    else if (status.toLowerCase().includes('bodega origen')) {
      this.estado = 'Bodega origen';
    }
    else if (status.toLowerCase().includes('bodega destino')) {
      this.estado = 'Bodega destino';
    }
    else if (status.toLowerCase().includes('reexpedicion')) {
      this.estado = 'Reexpedicion';
    }
    else if (status.toLowerCase().includes('producida') || status.toLowerCase().includes('producido')) {
      this.estado = 'Producida';
    }
    else if (status.toLowerCase().includes('anulado') || status.toLowerCase().includes('anulada')) {
      this.estado = 'Anulada';
    }
    else if (status.toLowerCase().includes('pendiente')) {
      this.estado = 'Pendiente';
    }
    else if (status.toLowerCase().includes('NA')) {
      this.estado = 'NA';
    }
    else if (status.toLowerCase().includes('devolucion')) {
      this.estado = 'Devolucion';
    }
    else if (status.toLowerCase().includes('proceso de Indemnización') || status.toLowerCase().includes('proceso de Indemnizacion')) {
      this.estado = 'Proceso de Indemnizacion';
    }
    else if (status.toLowerCase().includes('indemnizada') || status.toLowerCase().includes('indemnizado')) {
      this.estado = 'Indemnizada';
    }
    else if (status.toLowerCase().includes('despachado') || status.toLowerCase().includes('despachada')) {
      this.estado = 'Despachada';
    }
    else if (status.toLowerCase().includes('generado') || status.toLowerCase().includes('generada')) {
      this.estado = 'Generada';
    }
    else if (status.toLowerCase().includes('reparto') || status.toLowerCase().includes('en reparto')) {
      this.estado = 'En reparto';
    }
    else if (status.toLowerCase().includes('novedad')) {
      this.estado = 'Novedad';
    }
    else if (status.toLowerCase().includes('entregado') || status.toLowerCase().includes('entregada')) {
      this.estado = 'Entregado';
    }
  }

  darEstado(state: string) {
    // console.log("ESTA LLENGANDO ESTE ESTADO: " + state);
    if (state == 'Anulada' || state == 'Anulado') {
      //console.log('Anulado');
      this.checkedA = true;
      this.checkedP = false;
      this.checkedDev = false;
      this.checkedProInd = false;
      this.checkedInd = false;
      this.checkedNo = false;
      this.checkedD = '';
      this.checkedR = '';
      this.checkedPrep = '';
      this.checkedE = '';
      this.valueCheck = '100%';
      this.bgcheck = '#ff3333';
    }
    else if (state == 'Pendiente') {
      //console.log('Pendiente');
      this.checkedA = false;
      this.checkedP = true;
      this.checkedDev = false;
      this.checkedProInd = false;
      this.checkedNo = false;
      this.checkedInd = false;
      this.checkedD = '';
      this.checkedR = '';
      this.checkedPrep = '';
      this.checkedE = '';
      this.valueCheck = '100%';
      this.bgcheck = '#ff8800';
    }
    else if (state == 'Devolucion' || state == 'Devolución' || state == 'Devolucion-Entregada') {
      //console.log('Devolución');
      this.checkedA = false;
      this.checkedP = false;
      this.checkedDev = true;
      this.checkedProInd = false;
      this.checkedInd = false;
      this.checkedNo = false;
      this.checkedD = '';
      this.checkedR = '';
      this.checkedPrep = '';
      this.checkedE = '';
      this.valueCheck = '100%';
      this.bgcheck = '#ff8800';
    }
    else if (state == 'Proceso de Indemnización ' || state == 'Proceso de Indemnizacion' || state == 'En proceso de indemnizacion') {
      //console.log('Proceso de Indemnización');
      this.checkedA = false;
      this.checkedP = false;
      this.checkedDev = false;
      this.checkedProInd = true;
      this.checkedInd = false;
      this.checkedNo = false;
      this.checkedD = '';
      this.checkedR = '';
      this.checkedPrep = '';
      this.checkedE = '';
      this.valueCheck = '100%';
      this.bgcheck = '#ff8800';
    }
    else if (state == 'Indemnizada' || state == 'Indemnizado') {
      //console.log('Indemnizada');
      this.checkedA = false;
      this.checkedP = false;
      this.checkedDev = false;
      this.checkedProInd = false;
      this.checkedInd = true;
      this.checkedNo = false;
      this.checkedD = '';
      this.checkedR = '';
      this.checkedPrep = '';
      this.checkedE = '';
      this.valueCheck = '100%';
      this.bgcheck = '#ff8800';
    }
    else if (state == 'Novedad' || state == 'novedad') {
      //console.log('Novedad');
      this.checkedA = false;
      this.checkedP = false;
      this.checkedDev = false;
      this.checkedProInd = false;
      this.checkedInd = false;
      this.checkedNo = true;
      this.checkedPrep = '';
      this.checkedD = '';
      this.checkedR = '';
      this.checkedE = '';
      this.valueCheck = '100%';
      this.bgcheck = '#ff8800';
    }
    else if (state == 'Producida' || state == 'Producido' || state == 'NA' || state == 'En procesamiento') {
      //console.log('Preparación');
      this.checkedA = false;
      this.checkedP = false;
      this.checkedDev = false;
      this.checkedProInd = false;
      this.checkedInd = false;
      this.checkedNo = false;
      this.checkedPrep = 'activated';
      this.checkedD = '';
      this.checkedR = '';
      this.checkedE = '';
      this.valueCheck = '25%';
      this.bgcheck = '#ff8800';
    }
    else if (state == 'Despachado' || state == 'Despachada' || state == 'Bodega Destino' || state == 'Bodega destino' ||
      state == 'Bodega origen' || state == 'Bodega Origen' || state == 'En espera' || state == 'Redireccion' ||
      state == 'Reexpedicion' || state == 'Solucionado en malla' || state == 'Solucionado en Malla' || state == 'Generado'
      || state == 'Generada' || state == 'Salio a ciudad destino') {
      //console.log('Despachado');
      this.checkedA = false;
      this.checkedP = false;
      this.checkedDev = false;
      this.checkedProInd = false;
      this.checkedInd = false;
      this.checkedNo = false;
      this.checkedPrep = 'activated';
      this.checkedD = 'activated';
      this.checkedR = '';
      this.checkedE = '';
      this.valueCheck = '50%';
      this.bgcheck = '#ff8800';
    }
    else if (state == 'En reparto' || state === 'En zona de distribucion') {
      //console.log('reparto');
      this.checkedA = false;
      this.checkedP = false;
      this.checkedDev = false;
      this.checkedProInd = false;
      this.checkedInd = false;
      this.checkedNo = false;
      this.checkedPrep = 'activated';
      this.checkedD = 'activated';
      this.checkedR = 'activated';
      this.checkedE = '';
      this.valueCheck = '75%';
      this.bgcheck = '#ff8800';
    }
    else if (state == 'Entregada' || state == 'Entregado') {
      //console.log('Entregado');
      this.checkedA = false;
      this.checkedP = false;
      this.checkedDev = false;
      this.checkedProInd = false;
      this.checkedInd = false;
      this.checkedNo = false;
      this.checkedPrep = 'activated';
      this.checkedD = 'activated';
      this.checkedR = 'activated';
      this.checkedE = 'activated';
      this.valueCheck = '100%';
      this.bgcheck = '#66ff66';
    }
  }

  inicializarFormulario(): void {
    this.formRastreo = this.formBuild.group({
      numeroGuia: new FormControl(
        '',
        [
          // validaciones síncronas
          Validators.required,
        ],
        [
          // validaciones asíncronas
        ]
      ),
      password: new FormControl(''),
    });
  }

  messageWhatsapp(telefono: string): void {
    //console.log(telefono);
  }

  get numeroGuia(): any {
    return this.formRastreo.get('numeroGuia');
  }

  openModal(): void {
    this.muestra = true;
  }

  closeModal(): void {
    this.muestra = false;
  }

  actionButtonNumber() {
    this.showInput = true;
  }

  verifyNumber() {
    const number = this.phoneNumber;
    if (number !== null && number !== undefined) {
      if (number.toString().length >= 7) {
        this.setMessageError(false);
        this.getTrackingDataGuide(this.activatedRoute.snapshot.params.id, number);
      } else {
        this.setMessageError(true, 'No es un numero de telefono')
      }
    } else {
      this.setMessageError(true, 'Campo vacio')
    }
  }

  setMessageError(show: boolean, message?: string) {
    this.showErrorInput = show;
    this.messageInputPhone = message;
  }
}
